import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import { showLoader} from "../../../components/loader/loader";

// actions
import {
    setForm,
    setApp,
    setItem,
    ADD_STATE,
    REMOVE_STATE,
    setUdn
} from "../../../redux/actions/generics/IndexedActions";
import CategoryList from "./_list";



function Category(props) {
    const path = props.path || 'clasificators/category';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const localStorageUdn = localStorage.getItem('selectedUdn')
        if (localStorageUdn && localStorageUdn !== 'undefined') {
            try {
                const udn = JSON.parse(localStorageUdn);
                if (udn) {
                    props.setUdn(path, udn);
                }
            } catch (e) {
                console.error(e);
            }
        }
    },[]);

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    { componentState && <CategoryList path={path}/> }
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setUdn,
    setForm,
    setItem
});

export default connect(mapStateToProps, mapActionsToProps)(Category)

